import { render, staticRenderFns } from "./ComponentPalette.vue?vue&type=template&id=64bdf47c&"
import script from "./ComponentPalette.vue?vue&type=script&lang=js&"
export * from "./ComponentPalette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports